import { convertDate, localDateToUTCDate } from '../../../assets/ts/date-and-time/date-and-time'

export const detailsitems = (currentDueOut) => [
  {
    link: '#',
    subtitle: `${currentDueOut?.PASCODEServicedBy}`,
    title: 'Servicing By',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.['CustomerStatus']}`,
    title: 'Status ',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.DoDNumber}`,
    title: 'DoD ID Number',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.Rank}`,
    title: 'Rank',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.DutyEmail}`,
    title: 'Duty Email',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.DutyPhone}`,
    title: 'Duty Phone',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.PASCODE}`,
    title: 'PASCODE',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.Organization}`,
    title: 'Organization',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.Installation}`,
    title: 'Assigned Location',
  },
]

export const dueoutdetailsitems = (currentDueOut) => [
  {
    link: '#',
    subtitle: `${currentDueOut?.['Section/MetadataValue']}`,
    title: 'Section',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.['Category/MetadataValue']}`,
    title: 'Category',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.['SubCategory/MetadataValue'] ?? '-'}`,
    title: 'Sub Category ',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.ServicingBy}`,
    title: 'Servicing By',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.DueDate ?  convertDate(localDateToUTCDate(currentDueOut?.DueDate), '') : '-'}`,
    title: 'Due Date',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.RNLTD ? convertDate(localDateToUTCDate(currentDueOut?.RNLTD), '') : '-'}`,
    title: 'RNLTD',
  },
  {
    link: '#',
    subtitle: ` ${ currentDueOut?.PDD ? convertDate(localDateToUTCDate(currentDueOut?.PDD), '') : '-'}`,
    title: 'PDD',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.DOS ? convertDate(localDateToUTCDate(currentDueOut?.DOS) , '') : '-'}`,
    title: 'DOS',
  },
  {
    link: '#',
    subtitle: `${currentDueOut?.PRP === '' ?  '-': currentDueOut?.PRP }`,
    title: 'PRP',
  },
]
